import { render, staticRenderFns } from "./GFile.vue?vue&type=template&id=faec8a96&"
import script from "./GFile.vue?vue&type=script&lang=js&"
export * from "./GFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports